import { useNavigate } from 'react-router-dom'

import { F0Alert } from '@factorialco/f0-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

const Activate = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  return (
    <F0Alert
      title={i18n.t('engagement.pulse.activate.title_not_active')}
      description={i18n.t('engagement.pulse.activate.description_not_active')}
      action={{
        label: i18n.t('engagement.pulse.activate.button_activate'),
        onClick: () => {
          navigate(navigation.settings.engagement.fullPath())
        },
      }}
      variant="info"
    />
  )
}

export default Activate
